module.exports = __webpack_public_path__ + "img/pop_blue.68cdb64b.png";